import React from "react";

const ColorSymbol: React.FC = () => {
    const items = [
        { color: "#0063B2", label: "Tasking" },
        { color: "#9CC3D5", label: "Reviewing" },
        { color: "#bdbdbd", label: "Draft" },
        { color: "#4caf50", label: "Active" },
    ];

    return (
        <div
            style={{
                position: "absolute",
                bottom: 0,
                right: 0,
                background: "white",
                borderRadius: "8px",
                padding: "10px 14px",
                boxShadow: "0px 2px 8px rgba(0,0,0,0.15)",
                fontSize: "14px",
                lineHeight: "20px",
                zIndex: 10,
            }}
        >
            {items.map((item, index) => (
                <div key={index} style={{ display: "flex", alignItems: "center", marginBottom: "4px" }}>
                    <span
                        style={{
                            width: 14,
                            height: 14,
                            background: item.color,
                            borderRadius: "50%",
                            display: "inline-block",
                            marginRight: 8,
                        }}
                    />
                    <span>{item.label}</span>
                </div>
            ))}
        </div>
    );
};

export default ColorSymbol;
